import { Box, Table, Td, Tfoot, Th, Tr } from '@ff-it/ui';
import Big from 'big.js';
import { useTable } from 'components/ControlledTable';
import { ReactElement } from 'react';

type InvoiceFooterProps = {
  campaingTotal?: string;
};

export function InvoiceFooter({ campaingTotal }: InvoiceFooterProps): ReactElement | null {
  const { data } = useTable<{ campaign_bound: string }>();
  if (!data) {
    return null;
  }
  const linkedTotal = data.rows.reduce((acc, { campaign_bound }) => acc.plus(campaign_bound), Big(0));
  return (
    <Box ml="auto" style={{ maxWidth: '320px' }}>
      <Table data-testid="invoice-footer" width="auto" size="sm">
        <Tfoot>
          <Tr>
            <Td>Linked total</Td>
            <Td className="text-right" data-testid="linked-total">
              {linkedTotal.toFixed(2)}
            </Td>
          </Tr>
          {campaingTotal && (
            <>
              <Tr>
                <Td>Campaign total</Td>
                <Td className="text-right" data-testid="campaign-total">
                  {campaingTotal}
                </Td>
              </Tr>
              <Tr>
                <Th>Remaining</Th>
                <Th className="text-right" data-testid="remaining">
                  {Big(campaingTotal).minus(linkedTotal).toFixed(2)}
                </Th>
              </Tr>
            </>
          )}
        </Tfoot>
      </Table>
    </Box>
  );
}
